/* Wavyn wishlist + account entry points — localStorage based, no app required. */
(function () {
  var KEY = 'wavyn_wishlist_v1';
  var CARD_SELECTORS = '.wvh-card, .product-block, .product-card-wrapper, .card-wrapper, .card, li.grid__item, .wv-wish-card';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 5.6a5 5 0 0 0-7.1 0L12 7.3l-1.7-1.7a5 5 0 1 0-7.1 7.1L12 21l8.8-8.3a5 5 0 0 0 0-7.1z"/></svg>';
  var ACCOUNT_URL = 'https://shopify.com/78002094299/account';

  /* New customer accounts live on a Shopify-hosted domain. Point every account
     entry point straight at it so no storefront redirect is needed. */
  function fixAccountLinks(root) {
    (root || document).querySelectorAll('a[href$="/account/login"], a[href$="/account/register"], a[href$="/account"], a.wvd-signin').forEach(function (a) {
      a.setAttribute('href', ACCOUNT_URL);
      a.setAttribute('rel', 'nofollow');
    });
  }

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    paintCount();
    document.dispatchEvent(new CustomEvent('wavyn:wishlist', { detail: list }));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read(), i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1;
  }
  function handleFromHref(href) {
    if (!href) return null;
    var m = href.split('?')[0].split('#')[0].match(/\/products\/([^\/]+)$/);
    return m ? m[1] : null;
  }
  function paintCount() {
    var n = read().length;
    document.querySelectorAll('a[href*="/pages/wishlist"]').forEach(function (a) {
      var b = a.querySelector('.wv-wish-count');
      if (n === 0) { if (b) b.remove(); return; }
      if (!b) {
        b = document.createElement('span');
        b.className = 'wv-wish-count';
        if (getComputedStyle(a).position === 'static') a.style.position = 'relative';
        a.appendChild(b);
      }
      b.textContent = n;
    });
  }

  function decorate(root) {
    (root || document).querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var handle = handleFromHref(a.getAttribute('href'));
      if (!handle) return;
      var mount = a.querySelector('img') ? a : null;
      if (!mount) {
        var card = a.closest(CARD_SELECTORS);
        if (!card) return;
        var imgAnchor = card.querySelector('a[href*="/products/"] img');
        mount = imgAnchor ? imgAnchor.closest('a') : null;
      }
      if (!mount || mount.querySelector('.wv-wish')) return;
      if (getComputedStyle(mount).position === 'static') mount.style.position = 'relative';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wv-wish' + (has(handle) ? ' is-on' : '');
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.setAttribute('data-handle', handle);
      btn.innerHTML = HEART;
      mount.appendChild(btn);
    });
    paintCount();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.wv-wish') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var on = toggle(btn.getAttribute('data-handle'));
    document.querySelectorAll('.wv-wish[data-handle="' + btn.getAttribute('data-handle') + '"]').forEach(function (b) {
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
  });

  function money(cents) {
    var s = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '\u20b9' + parts.join('.');
  }

  function renderPage() {
    var root = document.getElementById('wv-wishlist-root');
    if (!root) return;
    var list = read();
    if (!list.length) {
      root.innerHTML = '<div class="wv-wish-empty">Nothing saved yet. Tap the heart on any product to keep it here.<br><a href="/collections/all">Browse the collection</a></div>';
      return;
    }
    root.innerHTML = '<div class="wv-wish-grid"></div>';
    var grid = root.firstChild;
    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var el = document.createElement('div');
        el.className = 'wv-wish-card';
        el.innerHTML =
          '<a class="wv-wish-shot" href="/products/' + p.handle + '">' +
          (img ? '<img src="' + img + '&width=700" alt="' + (p.title || '').replace(/"/g, '') + '" loading="lazy">' : '') +
          '</a>' +
          '<a class="wv-wish-name" href="/products/' + p.handle + '">' + p.title + '</a>' +
          '<div class="wv-wish-row"><span class="wv-wish-price">' + money(p.price) + '</span>' +
          '<button type="button" class="wv-wish-remove" data-remove="' + p.handle + '">Remove</button></div>';
        grid.appendChild(el);
        decorate(el);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var r = e.target.closest ? e.target.closest('[data-remove]') : null;
    if (!r) return;
    e.preventDefault();
    var list = read(), i = list.indexOf(r.getAttribute('data-remove'));
    if (i !== -1) { list.splice(i, 1); write(list); }
    renderPage();
  });

  function boot() { fixAccountLinks(document); decorate(document); renderPage(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { fixAccountLinks(e.target); decorate(e.target); renderPage(); });
  window.wavynWishlist = { read: read, toggle: toggle, has: has, refresh: boot };
})();
